<div class="lab-broker-footer">
	<button
		*ngIf="isSaveAndContinueLaterVisible"
		tlkButton
		variant="ghost"
		size="m"
		(click)="onSaveAndContinueLaterClicked()"
		data-testid="lab-broker-save-and-continue-later-button"
	>
		{{ 'SaveAndContinueLater.ButtonText' | translate }}
	</button>
	<button
		*ngIf="isSendToLabVisible"
		tlkButton
		variant="primary"
		size="m"
		(click)="onSendClicked()"
		data-testid="lab-broker-send-to-lab-button"
	>
		{{ 'LabBroker.SendToLabButton' | translate }}
	</button>
</div>
